import React from 'react'

export default function AddButton({ onClick, text }) {
    return (
        <button
            onClick={onClick}
            className={`  text-theme-headerBg text-sm   bg-theme-tableBg rounded-1  px-2   py-[2px]  `}
        >
            {text}
        </button>
    )
}